<div class="pgw--container">

  <div class="ui-g">

    <div class="ui-g-12">
      <h1>Depositar por PIX</h1>
    </div>

  </div>

  <div class="ui-g" style="padding: 20px 0px;">

    <div class="ui-g-12 ui-fluid" *ngIf="jwtPayload.usuarioEmail.includes('@pgwpay.com')">
      <p-dropdown [options]="empresasOptions" [(ngModel)]="depositoPixFilter.empresaId" (onChange)="buscarLicencas()"
        filter="true" resetFilterOnHide="true">
        <ng-template let-empresa pTemplate="item">
          <div class="flex align-items-center gap-2">
            <i *ngIf="empresa.ativa" class="pi pi-check"
              style="display: inline; font-weight: bold; color: green; margin-right: 10px;"></i>
            <i *ngIf="!empresa.ativa" class="pi pi-lock"
              style="display: inline; font-weight: bold; color: red; margin-right: 10px;"></i>
            <span>{{ empresa.label }}</span>
          </div>
        </ng-template>
      </p-dropdown>
    </div>

    <div class="ui-g-12 ui-fluid">
      <p-dropdown [options]="licencasOptions" [(ngModel)]="depositoPixFilter.licencaId" pTooltip="Contratos"
        tooltipPosition="top" (onChange)="alterarLicenca()" filter="true" resetFilterOnHide="true">
      </p-dropdown>
    </div>

    <div class="ui-g-12 ui-md-4 ui-lg-2 ui-fluid">
      <p-calendar [(ngModel)]="depositoPixFilter.rangeDates" selectionMode="range" [readonlyInput]="true"
        [maxDate]="maxDate" dateFormat="dd/mm/yy" placeholder="Período" pTooltip="Data de Início ou Período"
        tooltipPosition="top">
      </p-calendar>
    </div>

    <div class="ui-g-12 ui-md-4 ui-lg-2 ui-fluid">
      <p-dropdown [options]="depositoPixFilter.tpPeriodoOptions" [(ngModel)]="depositoPixFilter.tpPeriodo"
        pTooltip="Tipo de Período" tooltipPosition="top" (onChange)="alterarTipoPeriodo()">
      </p-dropdown>
    </div>

    <div class="ui-g-12 ui-md-4 ui-lg-2 ui-fluid">
      <p-dropdown [options]="depositoPixFilter.statusOptions" [(ngModel)]="depositoPixFilter.status" pTooltip="Status"
        tooltipPosition="top">
      </p-dropdown>
    </div>

    <div class="ui-g-12 ui-md-11 ui-lg-5 ui-fluid">
      <input pInputText [(ngModel)]="depositoPixFilter.historico" placeholder="Histórico" pTooltip="Histórico"
        tooltipPosition="top" />
    </div>

    <div class="ui-g-12 ui-md-1 ui-lg-1">
      <button pButton type="button" icon="pi pi-search" (click)="buscar()"></button>
    </div>

    <div class="ui-g-12">
      <button pButton label="Gerar PIX" icon="fas fa-qrcode" class="ui-button-primary" (click)="gerarPix()"
        *ngIf="hasPermission('DEPPIX_CRIAR')"></button>
    </div>

    <div class="ui-g-12 ui-fluid">
      <span *ngIf="!hasPermission('DEPPIX_CONSULTAR')">Obs.: Usuário sem permisão para consulta!</span>
      <p-table [value]="depositoPixList" [responsive]="true" selectionMode="single"
        (onRowSelect)="onRowSelect($event.data)" *ngIf="hasPermission('DEPPIX_CONSULTAR')">
        <ng-template pTemplate="header">
          <tr>
            <th style="width: 120px;">Dt/Hr Emissão</th>
            <th style="width: 120px;">Dt/Hr Pagamento</th>
            <th>Histórico</th>
            <th style="width: 120px;">Valor</th>
            <th style="width: 100px;">Status</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-depositoPix>
          <tr [pSelectableRow]="depositoPix">
            <td class="pgw--text-center">{{ depositoPix.dtHr | date: 'dd/MM/yyyy HH:mm:ss' }}</td>
            <td class="pgw--text-center">{{ depositoPix.dtHrPg | date: 'dd/MM/yyyy HH:mm:ss' }}</td>
            <td class="pgw--text-center">{{ depositoPix.historico }}</td>
            <td class="pgw--text-right">{{ depositoPix.valor | currency:'BRL':'symbol':'0.2-2':'pt' }}</td>
            <td class="pgw--text-center">{{ depositoPix.status }}</td>
          </tr>
        </ng-template>

      </p-table>
    </div>

    <div class="ui-g-12 ui-fluid" style="margin: 30px 0;">
      <p-table [value]="resumo.situacoes" *ngIf="resumo.situacoes.length > 0">

        <ng-template pTemplate="caption">
          Resumo
        </ng-template>

        <ng-template pTemplate="header">
          <tr>
            <th class="col-left">Status</th>
            <th class="col-right" style="width: 120px;">Qtd.</th>
            <th class="col-right" style="width: 150px;">Valor</th>
          </tr>
        </ng-template>

        <ng-template pTemplate="body" let-situacao>
          <tr>
            <td class="col-left">{{ situacao.status }}</td>
            <td class="col-right">{{ situacao.qtd }}</td>
            <td class="col-right">
              {{ situacao.vlr | currency:'BRL':'symbol':'0.2-2':'pt' }}
            </td>
          </tr>
        </ng-template>

        <ng-template pTemplate="footer">
          <tr>
            <td class="col-left">Total</td>
            <td class="col-right">{{ resumo.qtd }}</td>
            <td class="col-right">
              {{ resumo.vlr | currency:'BRL':'symbol':'0.2-2':'pt' }}
            </td>
          </tr>
        </ng-template>

      </p-table>

    </div>

  </div>

</div>

<nav *ngIf="exibir">
  <p-sidebar [(visible)]="exibir" position="left" styleClass="ui-sidebar-md">

    <app-extrato-deposito-pix-cadastro [depositoPix]="depositoPixSelected" [licenca]="licencaSelected"
      (onClose)="exibir = false" (onPixCreated)="onPixCreated($event)"></app-extrato-deposito-pix-cadastro>

  </p-sidebar>
</nav>
